import { render, staticRenderFns } from "./Tournament.vue?vue&type=template&id=72fe6389&scoped=true"
import script from "./Tournament.vue?vue&type=script&lang=js"
export * from "./Tournament.vue?vue&type=script&lang=js"
import style0 from "./Tournament.vue?vue&type=style&index=0&id=72fe6389&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe6389",
  null
  
)

export default component.exports